import FetchApi from "./api";
import config from "../config";

const serviceAuth = {
  authSignin: (payload) =>
    FetchApi(`${config.urls.apiBaseUrl}api/Account/login`, "POST", payload),
  authSignup: (payload) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Account/register`,
      "POST",
      payload
    ),
  authForgot: (payload) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Account/forgotpassword`,
      "POST",
      payload
    ),
  authReset: (payload) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Account/resetpassword`,
      "POST",
      payload
    ),
  authRefresh: () =>
    FetchApi(`${config.urls.apiBaseUrl}api/Account/refreshToken`, "POST"),
  authResendVerify: (params) =>
    FetchApi(
      `${config.urls.apiBaseUrl}api/Account/resendEmailConfirmationLink${params}`,
      "GET"
    ),
};

export default serviceAuth;
